import * as React from 'react';

import { Box, color } from '@coursera/coursera-ui';
import { SvgBookmarkFilled, SvgCheckSolid, SvgSuccess } from '@coursera/coursera-ui/svg';

import type { AVAILABLE } from 'bundles/enterprise-legacy-learner-home/constants/ProgramProductStates';
import {
  COMPLETED,
  ENROLLED,
  UNAVAILABLE,
} from 'bundles/enterprise-legacy-learner-home/constants/ProgramProductStates';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

type Props = {
  curriculumProduct: {
    productState: { state?: typeof AVAILABLE | typeof UNAVAILABLE | typeof COMPLETED | typeof ENROLLED };
    isWishlisted?: boolean;
  };
  isThemeDark?: boolean;
};

export function ProductCardState({
  curriculumProduct: {
    productState: { state },
    isWishlisted: isWishlistedAlt,
  },
  isThemeDark = false,
}: Props): JSX.Element {
  const isCompleted = state === COMPLETED;
  const isUnavailable = !isCompleted && state === UNAVAILABLE;
  const isEnrolled = !isCompleted && !isUnavailable && state === ENROLLED;
  const isWishlisted = !isCompleted && !isUnavailable && !isEnrolled && isWishlistedAlt;
  const textClassName = `p-r-1s ${isThemeDark ? 'secondaryTextThemeDark' : 'text-muted'}`;
  const iconColor = isThemeDark ? color.iconThemeDark : color.primary;
  return (
    <Box
      rootClassName="text-secondary-dark font-xs m-b-1s"
      alignItems="center"
      justifyContent="end"
      data-e2e="ProductCardState"
    >
      {isCompleted && (
        <Box alignItems="center">
          <span className={textClassName}>{_t('Completed')}</span>
          <SvgCheckSolid size={24} color={iconColor} />
        </Box>
      )}
      {isUnavailable && <span className={textClassName}>{_t('Unavailable')}</span>}
      {isEnrolled && (
        <Box alignItems="center">
          <span className={textClassName}>{_t('Enrolled')}</span>
          <SvgSuccess size={24} color={iconColor} />
        </Box>
      )}
      {isWishlisted && <SvgBookmarkFilled color={iconColor} />}
    </Box>
  );
}

export default ProductCardState;
